
import "./SingleProblem.css"


// Carefull with case here, difficulty ect (lowercase) are class names in the search bar
 
export default function Problem({problem_name, problem_difficulty, problem_topic, problem_modality, solved, even_or_odd, click_handler}){

    const class_name = even_or_odd ? "problem-row even" :  "problem-row odd"; 
    const difficultyColors = {
        Trivial:  '#ff66cc',
        Easy:     '#39FF14',
        Medium:   'orange',
        Hard:     'red',
      };

    const emojiMap = {
        "MCQ": "🔠",
        "Code": "🖥️",
        "Written": "✏️"
    }
    const color = difficultyColors[problem_difficulty];
    return(
        <div className={class_name} onClick={click_handler}>
            <div>
              
            </div>
            <div className="Name entry">
                {problem_name}

                {solved && 
                <div className="checkmark-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 21 21" role="img" aria-label="Green checkmark">
                        <title>Green checkmark</title>
                        <path d="M20 6L9 17l-5-5" fill="none" stroke="#28a745" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>}
                
            </div>
            <div className="Difficulty entry" 
                style={{
                    color: color,
                    textShadow: color
                }}
            >
                {problem_difficulty}
            </div>
            <div className="Topic entry">
                {problem_topic}
            </div>
            <div className="Modality entry"> 
               {problem_modality} {emojiMap[problem_modality]}
            </div>
        </div>
    );
}
